module.exports = __webpack_public_path__ + "img/lupin.c017de40.svg";